import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/orden",
    component: MasterLayout,
    children: [
      {
        path: "pendientes",
        name: "orden.pendientes",
        component: () => import("@/views/orden/pendientes/index.vue")
      },
      {
        path: "registro",
        name: "orden.registro",
        component: () => import("@/views/orden/registro/index.vue")
      },
      {
        path: "antiguos",
        name: "orden.antiguos",
        component: () => import("@/views/orden/antiguos/index.vue")
      },
      {
        path: "garantias",
        name: "orden.garantias",
        component: () => import("@/views/orden/garantias/index.vue")
      },
      {
        path: "pendgarantias",
        name: "orden.pendgarantias",
        component: () => import("@/views/orden/pendgarantias/index.vue")
      },
    ]
  }
]